import axios from 'axios'
import * as types from '../mutation-types'

const doToArrayObject = (datos, withSelection) => {
  let term = []
  if (withSelection) {
    term = [{ value: '', text: '-- SELECCION --' }]
  }
  let key = 0
  for (key in datos) {
    if (datos.hasOwnProperty(key)) {
      const bank = datos[key].tipo_banco ? datos[key].tipo_banco.nombre : null
      const type = datos[key].tipo_cuenta_contable_banco ? datos[key].tipo_cuenta_contable_banco.nombre : null
      term.push({
        value: datos[key].id,
        text: `${datos[key].nombre} (${bank}, ${type}, ${datos[key].numero})`,
      })
    }
  }

  return term
}

// state
export const state = {
  loading: true,
  projectBankAccounts: [],
  error: null,
}

// mutations
export const mutations = {
  [types.GET_PROJECT_BANK_ACCOUNTS_START] (state) {
    state.loading = true
    state.projectBankAccounts = []
    state.error = null
  },

  [types.GET_PROJECT_BANK_ACCOUNTS_SUCCESS] (state, { data, withSelection }) {
    state.loading = false
    state.projectBankAccounts = doToArrayObject(data, withSelection)
    state.error = null
  },

  [types.GET_PROJECT_BANK_ACCOUNTS_ERROR] (state, { error }) {
    state.loading = false
    state.projectBankAccounts = []
    state.error = error
  },
}

export const actions = {
  async getProjectBankAccounts ({ commit }, { projectId, withSelection }) {
    try {
      commit(types.GET_PROJECT_BANK_ACCOUNTS_START)
      const { data } = await axios.get(`/api/projects/project_bank_account/${projectId}`)

      commit(types.GET_PROJECT_BANK_ACCOUNTS_SUCCESS, { data, withSelection })
    } catch (e) {
      commit(types.GET_PROJECT_BANK_ACCOUNTS_ERROR, { error: null })
    }
  },
}

// getters
export const getters = {
  loadingProjectBankAccounts: state => state.loading,
  projectBankAccounts: state => state.projectBankAccounts,
  errorProjectBankAccounts: state => state.error,
}
